<template>
  <nav
    :class="{
      navbar: $route.path === '/',
      'other-navbar': $route.path !== '/',
    }"
    class="min-w-1400"
  >
    <div
      :class="{
        secondBox: $route.path === '/',
        'other-secondBox': $route.path !== '/',
      }"
      class="max-w-1400"
    >
      <div class="logo">
        <span class="title">Desarrollo Orígenes Fofor, S.A.P.I., de C.V.SOFOM, E.N.R.</span>
      </div>
      <ul class="nav-links">
        <li :class="{ 'active-link': isActive('/') }" class="Li1">
          <router-link to="/" class="nav-link1">
            <span class="routeText1">Inicio</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/about' }" class="Li2">
          <router-link to="/about" class="nav-link2">
            <span class="routeText2">Acerca de</span>
          </router-link>
        </li>
        <li
          :class="{ 'active-link': $route.path === '/introduce' }"
          class="Li3"
        >
          <router-link to="/introduce" class="nav-link3">
            <span class="routeText3">Contacto</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/protocol' }" class="Li4">
          <!-- <router-link to="/protocol" class="nav-link4">
            <span class="routeText4">Política de Privacidad</span>
          </router-link> -->
          <a href="https://www.desarrolloorigenesfofor.com.mx/viewprivacy/" class="nav-link3" target="_blank">
            <span class="routeText4">Política de Privacidad</span>
          </a>
        </li>
      </ul>
    </div>
    <div style="height: 130px"></div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      link1Color: "white",
    };
  },
  methods: {
    isActive(route) {
      return this.$route.path === route;
    },
  },
};
</script>
<style scoped>
.navbar {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  /* position: sticky;   */
  top: 0; /* 位于页面顶部 */
  z-index: 1000; /* 确保导航栏在其他元素上方 */
  height: 100px;
  position: absolute;
}
.secondBox {
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: 100px;
  padding: 0 30px;
  background-color: "";
  position: absolute;
}

.logo {
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
}

.logoImg {
  width: 60px;
  height: 60px;
}

.title {
  /* width: 520px; */
  height: 24px;
  font-size: 18px;
  font-family: SF Pro-Black Italic;
  font-weight: 600;
  color: #ffffff;
  line-height: 23px;
  padding-left: 17px;
  /* text-transform: uppercase; */
  /* border: 1px solid red; */
  width: 550px;
}

.routeText1,
.routeText2,
.routeText3,
.routeText4,
.routeText5 {
  font-size: 16px;
  font-family: SF Pro-Semibold;
  font-weight: 550;
  color: #fff;
  line-height: 29px;
  /* text-transform: uppercase; */
}

.nav-link1,
.nav-link2,
.nav-link3,
.nav-link4,
.nav-link5 {
  text-decoration: none;
  margin: 0 auto;
  text-align: center;
}

.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  /* 垂直居中对齐 */
  justify-content: center;
  /* 水平居中对齐 */
}

.nav-links li {
  display: flex;
  padding: 8px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 45px;
  padding-left: 4px;
  padding-right: 4px;
}
.Li1 {
  width: 100px;
}
.Li2 {
  width: 120px;
}
.Li3 {
  width: 120px;
}
.Li4 {
  width: 210px;
}
/* .Li5 {
  width: 250px;
} */
/* 这个如果给margin-right底部可能会出现边距的问题 */
/* .Li4 {
  width: 250px;
  
} */

.active-link {
  /* background: linear-gradient(45deg, #F59120, #F95C40); */
  background-color: #ffffff;
  border-color: #ffffff;
  /* 边框样式 */
  /* border: 2px solid #ffffff;  */
  border-radius: 10px;
}

.active-link .routeText1,
.active-link .routeText2,
.active-link .routeText3,
.active-link .routeText4,
.active-link .routeText5 {
  font-family: Inter-Extra Bold;

  color: #02376D;
}

.other-navbar {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  /* position: sticky;   */
  top: 0; /* 位于页面顶部 */
  height: 100px;
}

.other-secondBox {
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: 100px;
  padding: 0 30px;
  /* background-color: #595FF6; */
  background-image: url("@/page/desarrolloorigenesfofor/components/img/NavBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.secondBox,
.other-secondBox{
  padding: 0 100px 0 200px;
}
</style>